import React, { Component } from 'react';

export class About extends Component {
    render() {
      return (
        <div className="About">
        What ever About
        </div>
      );
    }
} 



// WEBPACK FOOTER //
// ./src/about.js